class IconCarousel extends SplideCarousel {
  constructor(section, splideOptions) {
    super(section, splideOptions)
    
    this.splideNav = this.section.querySelector('.js-icon-carousel-splide-nav');
    this.navListeners();
  }

  navListeners() {
    this.splideSlider.on('active', this.activeSlideEventListener.bind(this));
    this.splideNav.addEventListener('click', this.splideIconCarouselNavClick.bind(this))
  }

  removeSliderEventListeners() {
    this.splideSlider.off('active');
    this.splideNav.removeEventListener('click', this.splideIconCarouselNavClick);
  }

  activeSlideEventListener(slide) {
    const index = slide.index;
    const currentActiveButton = this.section.querySelector('.js-icon-carousel-splide-nav button:not(.eto-opacity-40)');
    const newActiveButton = this.section.querySelector(`.js-icon-carousel-splide-nav button[data-index="${index}"]`);

    currentActiveButton.classList.add('eto-opacity-40');
    newActiveButton.classList.remove('eto-opacity-40');

    this.splideNav.scroll({
      left: newActiveButton.offsetLeft - 20,
      behavior: "smooth",
    });
  }

  splideIconCarouselNavClick(event) {
    const index = event.target.dataset.index;
    const currentActiveButton = this.section.querySelector('.js-icon-carousel-splide-nav button:not(.eto-opacity-40)');

    this.splideSlider.go(parseInt(index));

    currentActiveButton.classList.add('eto-opacity-40');
    event.target.classList.remove('eto-opacity-40');

    this.splideNav.scroll({
      left: event.target.offsetLeft - 20,
      behavior: "smooth",
    });
  }
}